<template>
  <div >
    
        <div v-if="this.Datos.length > 0">
        <h6 style="margin-top: 0px;">{{Title}} {{this.EtiquetaArea}} en {{this.EtiquetaAnio}}</h6>
        </div>
        <div v-else>
        <h6 style="margin-top: 0px;">{{Title}} {{this.EtiquetaArea}} en {{this.EtiquetaAnio}} sin Datos</h6>
        </div>

        <div id="Volumen_table" class="table-responsive">
        <table class="table table-striped table-light table-hover table-sm">
            <thead class="thead-dark">
            <tr>
                <th>{{this.HNombre}}</th>
                <th>Ene</th>
                <th>Feb</th>
                <th>Mar</th>
                <th>Abr</th>
                <th>May</th>
                <th>Jun</th>
                <th>Jul</th>
                <th>Ago</th>
                <th>Sep</th>
                <th>Oct</th>
                <th>Nov</th>
                <th>Dic</th>
                <th>Ʃ</th>
            </tr>
            </thead>
            <tbody class="text-dark">
            <tr v-for="detalle in Tablas">
                <td><strong>{{detalle.Head}}</strong></td>
                <td>{{detalle.M01}}</td>
                <td>{{detalle.M02}}</td>
                <td>{{detalle.M03}}</td>
                <td>{{detalle.M04}}</td>
                <td>{{detalle.M05}}</td>
                <td>{{detalle.M06}}</td>
                <td>{{detalle.M07}}</td>
                <td>{{detalle.M08}}</td>
                <td>{{detalle.M09}}</td>
                <td>{{detalle.M10}}</td>
                <td>{{detalle.M11}}</td>
                <td>{{detalle.M12}}</td>
                <td><strong>{{detalle.Total}}</strong></td>
            </tr>
            <tr v-if="this.Tablas.length > 0">
                <td>Total:</td>
                <td><strong>{{this.Enero}}</strong></td>
                <td><strong>{{this.Febrero}}</strong></td>
                <td><strong>{{this.Marzo}}</strong></td>
                <td><strong>{{this.Abril}}</strong></td>
                <td><strong>{{this.Mayo}}</strong></td>
                <td><strong>{{this.Junio}}</strong></td>
                <td><strong>{{this.Julio}}</strong></td>
                <td><strong>{{this.Agosto}}</strong></td>
                <td><strong>{{this.Septiembre}}</strong></td>
                <td><strong>{{this.Octubre}}</strong></td>
                <td><strong>{{this.Noviembre}}</strong></td>
                <td><strong>{{this.Diciembre}}</strong></td>
                <td><strong>{{this.Grantotal}}</strong></td>
            </tr>
            </tbody>
        </table>
        </div>
        <div v-if="this.ShowGrafica==true" class="aling-center">
            <Grafica :options="chartOptions" style="min-height:400px; max-width:960px;" ></Grafica>
        </div>
            
  </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import highcharts from '@/../static/js/highchart'

export default {
    components: {
        Grafica : highcharts
    },
    props: {
        Datos: Array,
        EtiquetaArea: "",
        EtiquetaAnio: 0,
        Ingreso : false,
        Solicitud: false,
        HNombre: "",
        ShowGrafica: false
    },
    data(){
        return{
            Tablas: [],
            chartOptions: {
                chart: {
                    type: 'column'
                },
                title: {
                    text: 'Grafica de Documentos de Ingreso en 2020'
                },
                lang: {
                    viewFullscreen: "Ver en pantalla completa",
                    printChart: "Imprimir gráfica",
                    downloadJPEG: "Descargar imagen JPEG",
                    downloadPDF: "Descargar documento PDF",
                    downloadPNG: "Descargar imagen PNG",
                    downloadSVG: "Descargar imagen SVG"
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Population (millions)'
                    }
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    pointFormat: 'Documentos: <b>{point.y:.1f}</b>'
                },
                series: [{
                    name: 'Documentos',
                    color : '#000000',
                    data: [
                        ['Enero', 200],
                        ['Febrero', 150],
                        ['Marzo', 142],
                        ['Abril', 56],
                        ['Mayo', 210],
                        ['Junio', 12],
                        ['Julio', 35],
                        ['Agosto', 85],
                        ['Septiembre', 0],
                        ['Octubre', 56],
                        ['Noviembre', 190],
                        ['Diciembre', 112]
                    ],
                    dataLabels: {
                        enabled: true,
                        rotation: -90,
                        color: '#FFFFFF',
                        align: 'right',
                        format: '{point.y:.1f}', // one decimal
                        y: 10, // 10 pixels down from the top
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                        }
                    }
                ],
                pane: {
                    size: '100%'
                },
            }
        }
    },
    computed : {
        Enero : function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M01;
            },0)
        },
        Febrero: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M02;
            },0)
        },
        Marzo: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M03;
            },0)
        },
        Abril: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M04;
            },0)
        },
        Mayo: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M05;
            },0)
        },
        Junio: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M06;
            },0)
        },
        Julio: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M07;
            },0)
        },
        Agosto: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M08;
            },0)
        },
        Septiembre: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M09;
            },0)
        },
        Octubre: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M10;
            },0)
        },
        Noviembre: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M11;
            },0)
        },
        Diciembre: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.M12;
            },0)
        },
        Grantotal: function(){
            return this.Tablas.reduce(function(total, item){
                return total + item.Total;
            },0)
        },
        Title(){
            if(this.Ingreso == true && this.Solicitud == false)
            {return "Reporte de Ingreso de Documentos"}
            if(this.Ingreso == false && this.Solicitud == false)
            {return "Reporte de Reingreso de Documentos"}
            if(this.Ingreso == false && this.Solicitud == true)
            {
                {return "Solicitudes"}
            }
        }
    },
    mounted(){
        if(this.Datos.length>0)
        {
            this.Tablas = this.Datos;

           let Arreglo = [];
           Arreglo.push(["Enero", this.Enero]);
           Arreglo.push(["Febrero", this.Febrero]);
           Arreglo.push(["Marzo", this.Marzo]);
           Arreglo.push(["Abril", this.Abril]);
           Arreglo.push(["Mayo", this.Mayo]);
           Arreglo.push(["Junio", this.Junio]);
           Arreglo.push(["Julio", this.Julio]);
           Arreglo.push(["Agosto", this.Agosto]);
           Arreglo.push(["Septiembre", this.Septiembre]);
           Arreglo.push(["Octubre", this.Octubre]);
           Arreglo.push(["Noviembre", this.Noviembre]);
           Arreglo.push(["Diciembre", this.Diciembre]);

           this.chartOptions.series[0].data = Arreglo;
           if(this.Ingreso == true && this.Solicitud == false)
           {
               this.chartOptions.title.text = "Documentos de Ingreso en " + this.EtiquetaAnio;
               this.chartOptions.yAxis.title.text = "Documentos";
           }
            if(this.Ingreso == false && this.Solicitud == false)
           {
               this.chartOptions.title.text = "Documentos de Reingreso en " + this.EtiquetaAnio;
               this.chartOptions.yAxis.title.text = "Documentos";
           }
           if(this.Ingreso == false && this.Solicitud == true)
           {
               this.chartOptions.title.text = "Solicitudes  " + this.EtiquetaArea +" " + this.EtiquetaAnio;
               this.chartOptions.yAxis.title.text = "Solicitudes"
           }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/TablasIngreso.vue